import { Moment } from 'moment-timezone';
import { setDate } from '../../../functions/date-setter';
import { Unit } from '../unit';

export class WeightedVotingCategory
{
    id: number;
    name: string;
    organizationId: number;
    voteWeight: number;
    unitIds: number[];
    templateUnitIds: number[];
    templateUnits: Unit[];
    unitsCount: number;
    createdAt: Moment;
    updatedAt: Moment;
    deletedAt: Moment;

    constructor(weightedVotingCategory: any) {
        this.id = weightedVotingCategory.id ?? null;
        this.organizationId = weightedVotingCategory.organizationId ?? null;
        this.name = weightedVotingCategory.name ?? null;
        this.voteWeight = weightedVotingCategory.voteWeight ?? null;
        this.unitIds = weightedVotingCategory.unitIds ?? [];
        this.templateUnitIds = weightedVotingCategory.templateUnitIds ?? [];
        this.templateUnits = weightedVotingCategory.templateUnits ?? [];
        this.unitsCount = weightedVotingCategory.unitsCount ?? 0;
        this.createdAt = setDate(weightedVotingCategory.createdAt);
        this.updatedAt = setDate(weightedVotingCategory.updatedAt);
        this.deletedAt = setDate(weightedVotingCategory.deletedAt);
    }
}
